import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getColors = () => {
  const url = `${API_URL}/api/v1/color`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetColors(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetColors(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetColors({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetColors = (data) => ({
  type: types.cmGetColors,
  payload: data,
});

export const createColor = (name) => {
  const url = `${API_URL}/api/v1/color/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.post(url, { name }, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setCreateColor(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        dispatch(setCreateColor(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setCreateColor({ status: 'danger', error: true, message }));
      });
  };
};

export const setCreateColor = (data) => ({
  type: types.cmCreateColor,
  payload: data,
});

export const updateColor = (colorId, name) => {
  const url = `${API_URL}/api/v1/color/edit/${colorId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.put(url, { name }, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setUpdateColor(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        dispatch(setUpdateColor(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setUpdateColor({ status: 'danger', error: true, message }));
      });
  };
};

export const setUpdateColor = (data) => ({
  type: types.cmUpdateColor,
  payload: data,
});

export const deleteColorById = (colorId) => {
  const url = `${API_URL}/api/v1/color/${colorId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteColorById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        outputData['colorId'] = colorId;
        dispatch(setDeleteColorById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteColorById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteColorById = (data) => ({
  type: types.cmDeleteColorById,
  payload: data,
});
